<template>
    <div>
        <v-server-table ref="jsaEmpListTable" url="/jsa/employees" :columns="columns" :options="options">

            <template slot="id" slot-scope="props">
                <button class="btn btn-sm btn-link" title="Remove Employee from JSA" v-on:click="deleteEmployee(props.row.id)">
                    <span class="text-danger"><i class="fa fa-trash"></i></span>
                </button>
            </template>

            <template slot="jsa_name" slot-scope="props">
                <router-link :to="`/jsa/view/${props.row.jsa_id}`" v-if="$root.hasPermission('jsa.view.browse')">
                     {{ props.row.jsa_name }}
                 </router-link>
            </template>

            <template slot="employee_last_name" slot-scope="props">
                <router-link :to="`/employees/view/${props.row.employee_id}`" v-if="$root.hasPermission('employees.view')">
                     {{ props.row.employee_first_name }} {{ props.row.employee_last_name }} - {{ props.row.employee_number }}
                 </router-link>
                 <span v-else>
                     {{ props.row.employee_first_name }} {{ props.row.employee_last_name }} - {{ props.row.employee_number }}
                 </span>
            </template>

            <template slot="employee_signed_at" slot-scope="props">
                <span v-if="props.row.employee_signed_at">{{ props.row.employee_signed_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
            </template>

            <template slot="signature_file_id" slot-scope="props">
                <router-link :to="`/jsa/signature/${props.row.id}`" class="btn btn-xs btn-primary" v-if="props.row.signature_file_id == null">
                    <i class="fa fa-pencil"></i> Sign
                </router-link>
                <a :href="`/files/view/${props.row.signature_file_id}`" target="_blank" v-else>View Signature</a>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        props: ['jsa_id', 'employee_id'],

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                //columns: ['id', 'employee_last_name', 'employee_signed_at', 'signature_file_id'],
                options: {
                    headings: {
                        id: 'Actions',
                        jsa_name: 'JSA',
                        employee_last_name: 'Employee',
                        employee_signed_at: 'Signed At',
                        signature_file_id: 'Signature',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'employee_last_name',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('jsaEmployeeListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Include the asset
                        data.jsa_id = this.jsa_id;
                        data.employee_id = this.employee_id;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'jsa_employees.id',
                },
            }
        },

        computed: {
            columns(){
                //Check for JSA ID
                if(this.jsa_id)
                {
                    return ['id', 'employee_last_name', 'employee_signed_at', 'signature_file_id'];
                }

                if(this.employee_id)
                {
                    return ['id', 'jsa_name', 'employee_signed_at', 'signature_file_id'];
                }

                //Return ALL
                return ['id', 'jsa_name', 'employee_last_name', 'employee_signed_at', 'signature_file_id'];
            },
        },

        methods: {
            refresh(){
                this.$refs.jsaEmpListTable.refresh();
            },

            deleteEmployee(id){
                //Confirm it
                if(!confirm('Are you sure you want to remove this employee from the JSA?'))
                {
                    return;
                }

                //Send it
                this.$http
                .delete('/jsa/employees/'+id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Employee Removed');

                    //Refresh
                    this.$refs.jsaEmpListTable.refresh();

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                });
            },
        },
    }
</script>
